<!--
 * @Description: 
 * @Autor: 
 * @Date: 2021-06-02 14:10:37
 * @LastEditors: lzw
 * @LastEditTime: 2021-06-11 14:58:31
 * @FilePath: \燃气B端\src\components\modals\passwordvalidationmodal.vue
-->

<template>
  <a-modal
    :visible="visible"
    :width="400"
    title="密码验证"
    ok-text="确认"
    cancel-text="取消"
    centered
    :z-index="9999"
    @cancel="hideModal"
    @ok="handleSubmit"
  >
    <div>
      <p v-if="showSelectNum">已勾选{{ checkNum }}条记录</p>
      <slot></slot>
      <!-- <div>账号密码：
        <a-input style="width:70%"
                 v-model="password" />
      </div> -->
      <a-form
        :form="form"
        :layout="formLayout"
        :label-col="{ span: 7 }"
        :wrapper-col="{ span: 17 }"
        @submit="handleSubmit"
        @keyup.enter.native="handleSubmit"
      >
        <a-form-item label="账号密码">
          <a-input
            type="password"
            v-decorator="[
              'password',
              { rules: [{ required: true, message: '密码不能为空' }] },
            ]"
          />
        </a-form-item>
      </a-form>
    </div>
  </a-modal>
</template>

<script>
export default {
  data() {
    return {
      password: "",
      formLayout: "inline",
      form: this.$form.createForm(this),
    };
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    showSelectNum: {
      type: Boolean,
      default: true,
    },
    checkNum: {
      type: Number,
      default: 1,
    },
  },
  watch: {
    visible(val) {
      if (val) {
        console.log("密码验证");
        this.password = "";
        this.form.resetFields();
      }
    },
  },
  methods: {
    hideModal() {
      // this.visible = false;
      this.$emit("onPasswordHide");
    },
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          console.log(values.password);
          this.$emit("onPasswordOk", values.password);
        }
      });
    },
  },
};
</script>

<style scoped lang="less">
</style>



// WEBPACK FOOTER //
// src/components/modals/passwordvalidationmodal.vue